import { applyFont, media, tokens } from '@domain-group/fe-brary';
import { css } from '@emotion/core';
var colors = tokens.colors;
export var noResults = /*#__PURE__*/css("background-color:", colors.neutral.subdued.default, ";text-align:center;");
export var image = {
  name: "sm43lu",
  styles: "width:80px;height:80px;"
};
export var noResultsHeading = /*#__PURE__*/css("max-width:200px;", applyFont(tokens.typography.displaySmall), " ", media('>=tablet'), "{max-width:unset;", applyFont(tokens.typography.displayMedium), "}");
export var noResultsHeadingText = {
  name: "epvm6",
  styles: "white-space:nowrap;"
};
export var propertyAlertButton = {
  name: "h47494",
  styles: "display:flex;flex-direction:column;align-items:stretch;"
};
export var nearbyButton = /*#__PURE__*/css("background-color:", colors.neutral.heavy.default, ";:hover{background-color:", colors.neutral.heavy.hover, ";}:focus{background-color:", colors.neutral.heavy.default, ";}:active{background-color:", colors.neutral.heavy.pressed, ";}");